import PropTypes from 'prop-types';
import { getPrice } from '../../../../../common/routines/utils';

const PNFuneralTrustAgingSummaryRow = ({ rowData, id }) => {
  return (
    <tr key={id} className="table-body-tr">
      <td>{rowData.serviceType}</td>
      <td>{getPrice(rowData.contractAmount) || '-'}</td>
      <td>{getPrice(rowData.downPaymentAmount) || '-'}</td>
      <td>{getPrice(rowData.monthlyPayment) || '-'}</td>
      <td>{getPrice(rowData.unDue) || '-'}</td>
      <td>{getPrice(rowData.overDue) || '-'}</td>
      <td>{getPrice(rowData.day30) || '-'}</td>
      <td>{getPrice(rowData.day60) || '-'}</td>
      <td>{getPrice(rowData.day90) || '-'}</td>
      <td>{getPrice(rowData.day120) || '-'}</td>
      <td>{getPrice(rowData.day640) || '-'}</td>
      <td>{getPrice(rowData.day670) || '-'}</td>
      <td>{getPrice(rowData.day700) || '-'}</td>
      <td>{getPrice(rowData.day730) || '-'}</td>
      <td>{getPrice(rowData.above730) || '-'}</td>
    </tr>
  );
};
PNFuneralTrustAgingSummaryRow.propTypes = {
  rowData: PropTypes.shape({
    serviceType: PropTypes.string,
    contractAmount: PropTypes.number,
    downPaymentAmount: PropTypes.number,
    monthlyPayment: PropTypes.number,
    unDue: PropTypes.number,
    overDue: PropTypes.number,
    day30: PropTypes.number,
    day60: PropTypes.number,
    day90: PropTypes.number,
    day120: PropTypes.number,
    day640: PropTypes.number,
    day670: PropTypes.number,
    day700: PropTypes.number,
    day730: PropTypes.number,
    above730: PropTypes.number,
  }).isRequired,
  id: PropTypes.string.isRequired,
};

export default PNFuneralTrustAgingSummaryRow;
